import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import OurServiceOffer from '../../Components/Automation/OurServiceOffer'
import { ChevronRight } from 'lucide-react'
import Perspectives from '../../Components/Accelerating/Perspectives'
import RelatedServices from '../../Components/Accelerating/RelatedServices'
import AccContact from '../../Components/Accelerating/AccContact'
import ScrollToTop from '../../Components/ScrollToTop'
import Banner from '../../Components/Banner'
import { Helmet } from 'react-helmet-async'
import ContactSection from '../../Components/home/ContactSection'

const relatedService = [
    {
        id: 1,
        title: "AI & Intelligent Automation",
        description: "Use AI and machine learning to simplify complex tasks, improve everyday efficiency, and help your team make smarter, more confident decisions backed by real data.",
        image: "/assets/product/p1.png",
        link: "/ai-intelligent-automation"
    },
    {
        id: 2,
        title: "ServiceNow Digital Workflows",
        description: "Bring your enterprise operations together on one simple cloud platform. Automate IT, employee, and customer workflows so your teams can work smoother, faster, and with less effort, while everything stays connected and easy to manage.",
        image: "/assets/product/p3.png",
        link: "/servicenow-digital-workflows"
    },
    {
        id: 3,
        title: "Embedded Systems & Industrial",
        description: "We design and build reliable embedded systems and industrial IoT solutions that make devices smarter, more connected, and truly efficient in real-world use.",
        image: "/assets/product/p4.png",
        link: "/embedded-systems-industrial"
    },
    {
        id: 4,
        title: "Managed Services & Staff Augmentation",
        description: "Grow your team quickly with skilled professionals and reliable managed services that ensure your important IT projects are delivered smoothly and without stress.",
        image: "/assets/product/p2.png",
        link: "/managed-services-staff-augmentation"
    }
];


const data = [
    {
        id: 1,
        category: "ERP STRATEGY",
        title: "Navigating the Complexities of ERP Digital Transformation",
        link: "#"
    },
    {
        id: 2,
        category: "CLOUD MIGRATION",
        title: "Best Practices for Migrating Mission-Critical ERPs to the Cloud",
        link: "#"
    },
    {
        id: 3,
        category: "DATA INTELLIGENCE",
        title: "Breaking Down Silos: Unified Data Architectures for Enterprise Apps",
        link: "#"
    },
    {
        id: 4,
        category: "INTELLIGENT ERP",
        title: "Infusing Generative AI into Enterprise Resource Planning Workflows",
        link: "#"
    }
];

const service = [
    {
        id: 1,
        title: "Infor M3 Implementation & Support",
        category: "service",
        desc: "End-to-end Infor M3 deployment and support to help you simplify operations, improve visibility, and run your manufacturing, distribution, and equipment processes more smoothly.",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
        link: "/infor-m3-solutions",
    },
    {
        id: 2,
        title: "Enterprise Performance Management (EPM)",
        category: "service",
        desc: "Make financial planning, budgeting, and forecasting simpler and smarter, so you can make better decisions, stay agile, and confidently grow your business.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
        link: "/infor-epm-services",
    },
    {
        id: 3,
        title: "SAP & Oracle ERP Services",
        category: "service",
        desc: "Practical consulting, smooth migration, and reliable support for SAP and Oracle helping your business run better, save time, and get more value from your systems.",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
        link: "/",
    },
    {
        id: 4,
        title: "Glokode ERP (Custom ERP Solutions)",
        category: "service",
        desc: "ERP solutions built around your unique workflows are simple, flexible, and designed to grow with your business as your needs evolve.",
        defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
        link: "/glodesk",
    },
    {
        id: 5,
        title: "Application Modernization",
        category: "service",
        desc: "Upgrade your legacy applications with cloud-native and microservices to improve performance, scale easily, and create a smoother, more enjoyable user experience.",
        defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
        link: "/",
    },
    {
        id: 6,
        title: "ERP Integrations & Customization",
        category: "service",
        desc: "Easily connect your systems and customize ERP modules to bring all your data together, simplify workflows, and automate everyday business processes.",
        defaultBg: "bg-gradient-to-t from-[#01386A] to-[#243B55]",
        link: "/",
    },
]

function EnterpriseApplicationsERP() {
    return (
        <div>
            <Helmet>
    <title>
        Enterprise Applications & ERP Solutions | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode delivers enterprise applications and ERP solutions to simplify business operations, modernize legacy systems, connect enterprise data, and improve decision-making with scalable digital solutions."
    />

    <meta
        name="keywords"
        content="Enterprise Applications, ERP Solutions, ERP Consulting Services, Enterprise ERP Solutions, Infor M3 Services, Infor M3 Implementation, SAP ERP Services, Oracle ERP Services, ERP Integration Services, ERP Customization, Application Modernization, Enterprise Application Modernization, ERP Digital Transformation, EPM Solutions"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/capabilities/enterprise-applications"
    />

    <meta
        property="og:title"
        content="Enterprise Applications & ERP Solutions | Mobikode"
    />

    <meta
        property="og:description"
        content="Modernize your enterprise with Mobikode's ERP and enterprise application solutions. From Infor M3 and SAP to Oracle, EPM, application modernization, and ERP integrations, we help businesses build connected and efficient operations."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/capabilities/enterprise-applications"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/what/c2.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Enterprise Applications & ERP Solutions | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's enterprise application and ERP services including Infor M3, SAP, Oracle, EPM, application modernization, ERP integration, and custom enterprise solutions."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/what/c2.png"
    />
</Helmet>
            <ScrollToTop />
            <AiHero title="Enterprise Applications" imgData="/assets/what/c2.png" />
            <section className="w-full py-[50px] lg:py-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    {/* Changed: flex-col for mobile, lg:flex-row for desktop. Height auto for mobile. */}
                    <div className="relative w-full flex flex-col lg:flex-row h-auto lg:h-[323px] group">

                        {/* Image Container */}
                        {/* Changed: Fixed height on mobile (250px), full height on desktop */}
                        <div className="overflow-hidden w-full lg:max-w-[624px] h-[250px] lg:h-full relative z-10">
                            <img
                                src="/assets/what/item16.png"
                                alt="ai automation"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>

                        <div className="relative z-20 w-full lg:max-w-[656px] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] 
                            px-[20px] py-[30px] lg:px-[40px] flex justify-center flex-col lg:py-[30px] 
                            -mt-6 lg:mt-0 lg:ml-0">

                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-[500] font-graphik text-justify">
                                At Mobikode, we help businesses make their day-to-day operations simpler and more connected with modern Enterprise Applications and ERP solutions. We take complex processes and turn them into smooth, easy workflows by upgrading systems and removing data gaps, so teams can work better, make smarter decisions, and grow with confidence.  </p>

                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                        </div>

                    </div>
                </div>
            </section>
            <OurServiceOffer service={service} />
            {/* <section className='overflow-hidden'>
                <div className="max-w-[1440px] lg:pb-[80px] pb-[40px] w-full mx-auto lg:px-[80px] px-[20px]">
                    <h6 className="text-center font-[600] lg:text-[31px] text-[20px] lg:pb-[80px] pb-[40px] lg:leading-[40px] leading-[30px] text-[#01386A]">Spotlight</h6>
                    <div className="flex lg:flex-row flex-col gap-5">
                        <div className="w-full lg:w-[65%] mx-auto relative group">
                            <div className="relative w-full h-[350px] lg:h-auto lg:aspect-auto">
                                <img src="/assets/what/img6.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px]">Deploying an automated collaborative platform to improve PDI scoring for a fortune 500 manufacturer</h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full lg:w-[35%] mx-auto grid gap-[20px]">

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img5.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Deploying an automated collaborative platform to .....
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img7.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Deploying an automated collaborative platform to .....
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section> */}
            <section className="w-full pb-[40px] lg:pb-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/what/img8.png"
                                alt="Enterprise ERP Solutions"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[719px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">
                            <h3 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[35px] leading-[1.3]">
                                The Mobikode ERP Advantage
                            </h3>
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                We believe ERP should make your work easier, not more complicated. At Mobikode, we move away from outdated systems and build flexible, cloud-based solutions that keep everything connected. With the right mix of automation and insights, we help you simplify operations, make better decisions, and grow your business with confidence.</p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section>
                <div className="max-w-[1440px] w-full mx-auto lg:pl-[80px] pl-[20px]">
                    <h6 className="font-[600] font-sora lg:text-[31px] text-[20px] leading-[40px] text-[#01386A] text-lg:center">Mobikode Perspectives leading-[30px]</h6>
                </div>
            </section> */}
            {/* <Perspectives data={data} /> */}
            <RelatedServices relatedService={relatedService} />
            {/* <section className='relative'>
                <img src="/assets/product/bg1.jpg" className='lg:h-[683px] h-[800px] w-full object-cover' alt="" />
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] top-1/2 -translate-y-1/2 absolute left-1/2 -translate-x-1/2">
                    <AccContact />
                </div>
            </section> */}
            <Banner title="Enterprise Applications" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
            <ContactSection/>
        </div>
    )
}

export default EnterpriseApplicationsERP
